// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-input_inputContainer__xIoGm {
  cursor: text;

  display: flex;
  align-items: center;

  box-sizing: border-box;
  width: 100%;
  height: 60px;
  padding: 0 8px 0 0;
  border: 1px solid var(--borderColor);
  border-radius: 3px;

  font-size: 16px;
  font-weight: 700;
  color: var(--textColor);
  text-align: left;

  background-color: transparent;
  outline: 1px solid transparent;

  transition-timing-function: ease-in-out;
  transition-duration: 0.2s;
  transition-property: border-color, background-color, outline-color;
}
.text-input_inputContainer__xIoGm:focus-within {
    border-color: var(--primaryColor);
    outline-color: var(--primaryColor);
  }
.text-input_inputContainer__xIoGm:has(input:hover) {
    background-color: var(--hoverBackground);
  }
.text-input_inputContainer__xIoGm .text-input_input__PPUN7 {
    cursor: inherit;

    box-sizing: border-box;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0 8px 0 16px;
    border: none;

    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    color: var(--textColor);

    -webkit-appearance: none;

            appearance: none;
    background-color: transparent;
    outline: none;
  }
.text-input_inputContainer__xIoGm .text-input_input__PPUN7::placeholder {
      color: var(--borderColor);
    }
`, "",{"version":3,"sources":["webpack://./src/components/text-input/text-input.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;;EAEZ,aAAa;EACb,mBAAmB;;EAEnB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;;EAEhB,6BAA6B;EAC7B,8BAA8B;;EAE9B,uCAAuC;EACvC,yBAAyB;EACzB,kEAAkE;AAiCpE;AA/BE;IACE,iCAAiC;IACjC,kCAAkC;EACpC;AACA;IACE,wCAAwC;EAC1C;AAEA;IACE,eAAe;;IAEf,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,qBAAqB;IACrB,YAAY;;IAEZ,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;;IAEvB,wBAAgB;;YAAhB,gBAAgB;IAChB,6BAA6B;IAC7B,aAAa;EAKf;AAHE;MACE,yBAAyB;IAC3B","sourcesContent":[".inputContainer {\n  cursor: text;\n\n  display: flex;\n  align-items: center;\n\n  box-sizing: border-box;\n  width: 100%;\n  height: 60px;\n  padding: 0 8px 0 0;\n  border: 1px solid var(--borderColor);\n  border-radius: 3px;\n\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--textColor);\n  text-align: left;\n\n  background-color: transparent;\n  outline: 1px solid transparent;\n\n  transition-timing-function: ease-in-out;\n  transition-duration: 0.2s;\n  transition-property: border-color, background-color, outline-color;\n\n  &:focus-within {\n    border-color: var(--primaryColor);\n    outline-color: var(--primaryColor);\n  }\n  &:has(input:hover) {\n    background-color: var(--hoverBackground);\n  }\n\n  & .input {\n    cursor: inherit;\n\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0 8px 0 16px;\n    border: none;\n\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n    color: var(--textColor);\n\n    appearance: none;\n    background-color: transparent;\n    outline: none;\n\n    &::placeholder {\n      color: var(--borderColor);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `text-input_inputContainer__xIoGm`,
	"input": `text-input_input__PPUN7`
};
export default ___CSS_LOADER_EXPORT___;
